"use strict";
// ─── Curve di dominio Recovery (fattori → recovery %) ────────────────────────
// Fonte unica delle curve prima inline in apps/backend recovery-calculations.ts.
// Pure, testabili, senza dipendenze.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAW_RPE_RECOVERY_TABLE = void 0;
exports.computeAcwrRecovery = computeAcwrRecovery;
exports.computeSrpeRelativeRecovery = computeSrpeRelativeRecovery;
exports.computeRawRpeRecovery = computeRawRpeRecovery;
/**
 * Curva a campana ACWR → recovery % (spec sez. 3.4).
 * Breakpoints: <0.50→5, 0.50-0.80→5..60, 0.80-1.05→60..100,
 *              1.05-1.30→100..60, 1.30-1.50→60..15, >1.50→10.
 */
function computeAcwrRecovery(acwr) {
    if (acwr < 0.5)
        return 5;
    if (acwr < 0.8)
        return 5 + ((acwr - 0.5) / (0.8 - 0.5)) * (60 - 5);
    if (acwr < 1.05)
        return 60 + ((acwr - 0.8) / (1.05 - 0.8)) * (100 - 60);
    if (acwr <= 1.3)
        return 100 - ((acwr - 1.05) / (1.3 - 1.05)) * (100 - 60);
    if (acwr <= 1.5)
        return 60 - ((acwr - 1.3) / (1.5 - 1.3)) * (60 - 15);
    return 10;
}
/**
 * sRPE relativo (ratio sessione/media) → recovery % (spec sez. 3.5).
 * Breakpoints: <0.50→50, 0.50-0.80→50..80, 0.80-1.00→80..100,
 *              1.00-1.20→100..80, 1.20-1.50→80..20, >1.50→20.
 */
function computeSrpeRelativeRecovery(ratio) {
    if (ratio < 0.5)
        return 50;
    if (ratio < 0.8)
        return 50 + ((ratio - 0.5) / (0.8 - 0.5)) * (80 - 50);
    if (ratio < 1.0)
        return 80 + ((ratio - 0.8) / (1.0 - 0.8)) * (100 - 80);
    if (ratio <= 1.2)
        return 100 - ((ratio - 1.0) / (1.2 - 1.0)) * (100 - 80);
    if (ratio <= 1.5)
        return 80 - ((ratio - 1.2) / (1.5 - 1.2)) * (80 - 20);
    return 20;
}
/**
 * Fallback RPE grezzo (<21gg di storia) → recovery %.
 * Tabella anchor smoothed (bug-fix CSM09): 1→95 … 10→15.
 */
exports.RAW_RPE_RECOVERY_TABLE = {
    1: 95,
    2: 92,
    3: 88,
    4: 78,
    5: 72,
    6: 58,
    7: 52,
    8: 32,
    9: 28,
    10: 15,
};
function computeRawRpeRecovery(rpe) {
    const clamped = Math.max(1, Math.min(10, Math.round(rpe)));
    return exports.RAW_RPE_RECOVERY_TABLE[clamped];
}
